import { Form, SearchInput } from "@saas-ui/react";
import React, { useEffect } from "react";

export const SearchBar = ({
  defaultValue,
  placeholder,
  onSubmit,
}: {
  defaultValue?: string;
  placeholder: string;
  onSubmit: (value?: string) => void;
}) => {
  const [search, setSearch] = React.useState(defaultValue || "");

  useEffect(() => {
    setSearch(defaultValue || "");
  }, [defaultValue]);

  const submit = (value: string) => {
    onSubmit(value === "" ? undefined : value);
  };

  return (
    <Form
      className="w-full max-w-96"
      onSubmit={(e) => {
        submit(search);
      }}
    >
      <SearchInput
        data-cy="search-bar"
        placeholder={placeholder}
        size="sm"
        name="search"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        onReset={() => {
          setSearch("");
          submit("");
        }}
      />
    </Form>
  );
};
